function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVip2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.0197 7.70588C17.0197 9.09496 16.6192 10.3691 15.93 11.4325C14.9241 12.9652 13.3314 14.0477 11.478 14.3255C11.1614 14.383 10.8354 14.4118 10.5001 14.4118C10.1648 14.4118 9.8388 14.383 9.52214 14.3255C7.6687 14.0477 6.07606 12.9652 5.07017 11.4325C4.38096 10.3691 3.98047 9.09496 3.98047 7.70588C3.98047 3.99849 6.89566 1 10.5001 1C14.1045 1 17.0197 3.99849 17.0197 7.70588Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2694 16.7649L17.7052 17.1384C17.3544 17.2246 17.0795 17.4927 17.0036 17.847L16.6718 19.2546C16.4917 20.0206 15.5247 20.2504 15.0222 19.6472L10.5 14.3998L5.97781 19.6567C5.47534 20.26 4.50833 20.0302 4.32821 19.2641L3.99639 17.8565C3.91106 17.5022 3.63613 17.2246 3.29483 17.148L1.73055 16.7745C1.01004 16.6022 0.754063 15.6925 1.27549 15.1658L4.97288 11.4314C5.99677 12.9635 7.61793 14.0455 9.50455 14.3232C9.82689 14.3807 10.1587 14.4094 10.5 14.4094C10.8413 14.4094 11.1731 14.3807 11.4955 14.3232C13.3821 14.0455 15.0032 12.9635 16.0271 11.4314L19.7245 15.1658C20.2459 15.6829 19.99 16.5926 19.2694 16.7649Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0317 4.81007L11.5921 5.93361C11.668 6.08596 11.8675 6.23831 12.0479 6.26688L13.0641 6.43826C13.7099 6.543 13.8618 7.01908 13.3965 7.48564L12.6082 8.27593C12.4753 8.40923 12.3993 8.66633 12.4468 8.85676L12.6747 9.83749C12.8551 10.6087 12.4468 10.9134 11.763 10.504L10.8133 9.94221C10.6424 9.83747 10.3575 9.83747 10.1865 9.94221L9.23683 10.504C8.55306 10.9039 8.14469 10.6087 8.32513 9.83749L8.55306 8.85676C8.59104 8.67585 8.52457 8.40923 8.39161 8.27593L7.60337 7.48564C7.13802 7.01908 7.28997 6.55252 7.93576 6.43826L8.95193 6.26688C9.12287 6.23831 9.3223 6.08596 9.39828 5.93361L9.9586 4.81007C10.234 4.20068 10.7278 4.20068 11.0317 4.81007Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip2);
export default __webpack_public_path__ + "static/media/vip2.786bfe52edd04a51d652891c3f35ece6.svg";
export { ForwardRef as ReactComponent };